angular.module('mtic.components.notifications')
.directive('cyclePrompt', function ($log, EventManager, $timeout, language, userAccount, api, notificationService) {
  return {
    templateUrl: 'template.html',
    scope: {
    },
    link: function (scope) {
      var eventManager = new EventManager('cyclePrompt');
      scope.languageService = language;
      scope.isTeacher = userAccount.getData().role.isTeacher;
      scope.c4_prompt = {
        class_choice_c2 : false,
        class_choice_c3_1 : false,
        class_choice_c3_2 : false,
        class_choice_c4_1 : false,
        class_choice_c4_2 : false,
        class_choice_g78 : false,
      }
      scope.c4_prompt_radio_selection = {selection:null}
      scope.submit_teacher_cycle_prompt = function(){    
        if(!scope.isTeacher){
          scope.c4_prompt = {
            class_choice_c2 : false,
            class_choice_c3_1 : false,
            class_choice_c3_2 : false,
            class_choice_c4_1 : false,
            class_choice_c4_2 : false,
            class_choice_g78 : false,
          }
          scope.c4_prompt[scope.c4_prompt_radio_selection.selection] = true;
        }    
        
        notificationService.dismissNotification(scope.c4_prompt);
      }
      scope.no_c4_prompt_selection = function(){
        var one_selected = true;
        for(var key in scope.c4_prompt){
          if(scope.c4_prompt[key]){
            one_selected = false;
          }
        }
        return one_selected;
      }
    }
  }
})
